import { inject, Injectable } from '@angular/core';
import { ShippingLabelDbService } from './shipping-label-db.service';
import { ShippingLabel } from './shipping-label.models';

@Injectable({ providedIn: 'root' })
export class ShippingLabelService {

  private shippingLabelDbService = inject(ShippingLabelDbService);


  /**
   * Get a shipping label by its ID
   * @param labelId ID of the shipping label to retrieve
   * @returns Promise resolving to the shipping label
   */
  getShippingLabel(labelId: string): Promise<ShippingLabel> {
    return this.shippingLabelDbService.get(labelId);
  }

  /**
   * Get a shipping label by the associated order ID
   * @param orderId ID of the order to find the shipping label for
   * @returns Promise resolving to the shipping label
   */
  getShippingLabelByOrderId(orderId: string): Promise<ShippingLabel> {
    return this.shippingLabelDbService.getOneWhere({ where: { orderId: orderId } });
  }

}
